import Marquee from "react-fast-marquee";

const items = [
  "Precision", "Fabrication", "Laser Cutting", "CNC Machining", "Press Brake",
  "Powder Coating", "MIG / TIG Welding", "Tool Room", "Sheet Metal", "OEM Manufacturing",
];

const EditorialMarquee = ({ dark = false }) => {
  return (
    <section
      className={`relative overflow-hidden border-y py-10 ${dark ? "border-white/10 bg-ink" : "border-navy/10 bg-surface"}`}
      data-testid="editorial-marquee"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className={`font-display text-5xl font-bold tracking-tight sm:text-7xl ${dark ? "text-outline-light" : "text-outline"}`}>
              {t}
            </span>
            <span className={`h-3 w-3 rounded-full ${dark ? "bg-brand-soft" : "bg-brand"}`} />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
